import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-money",
  "use": "rt-portal-money-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-portal-money\"><defs><style type=\"text/css\"></style></defs><path d=\"M239.616 146.432h75.776l196.608 352.256 196.608-352.256h75.776l-216.064 374.784H733.184V563.2h-188.416v107.52h188.416V712.704h-188.416v164.864h-65.536V712.704h-188.416v-41.984h188.416V563.2h-188.416v-41.984h164.864L239.616 146.432z\" fill=\"\" p-id=\"9955\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/money.svg
// module id = 692
// module chunks = 99